import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {app_info} from "../../actions/AppInfo";

/*
	Keeps already open browser tabs in sync with the shop mode.

	The mode is switched in the database while the shop is running, so a tab
	that was loaded before the switch would otherwise keep showing enabled
	buttons until the customer reloads. Re-reading /api/app_info costs a few
	hundred bytes; hidden tabs are skipped so background tabs cost nothing.
*/
class ShopModePoller extends React.Component {
	static defaultProps = {
		interval: 60000
	};

	static propTypes = {
		interval: PropTypes.number
	};

	componentDidMount() {
		this.timer = setInterval(this.refresh, this.props.interval);
	}

	componentWillUnmount() {
		clearInterval(this.timer);
	}

	refresh = () => {
		if (typeof document !== "undefined" && document.hidden) return;
		// the generated action rejects on a network error and nobody else is
		// listening here - a missed poll is simply retried on the next tick
		this.props.dispatch(app_info()).catch(() => {});
	};

	render() {
		return null;
	}
}

export default connect()(ShopModePoller);
